import { createFileRoute, redirect } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { listPaginationLoaderDeps } from '../../list/pagination/list-pagination-loader-deps.ts';
import type { jobsQuery as TQuery } from '../../jobs/__generated__/jobsQuery.graphql.ts';
import relayReq from '../../jobs/__generated__/jobsQuery.graphql.ts';
import type { jobsQueryFragment$data } from '../../jobs/__generated__/jobsQueryFragment.graphql.ts';
import { Jobs } from '../../jobs/jobs.tsx';
import { jobsSearchSchema } from '../../jobs/jobs-search-schema.ts';
import { relayEnv } from '../../relay/relay-env.ts';

type TJobKeys = keyof jobsQueryFragment$data['content'][number];

export const Route = createFileRoute('/_index/jobs')({
    beforeLoad: () => {
        throw redirect({ replace: true, to: '..' });
    },
    component: Jobs,
    // errorComponent: () => <div>err</div>,
    loaderDeps: ({ search: { pageNum, pageSize, search, sortBy, sortDir } }) => ({
        ...listPaginationLoaderDeps(pageNum, pageSize),
        search,
        sortBy,
        sortDir,
    }),
    loader: (ctx) => {
        const searchBy: TJobKeys[] = ['name', 'group', 'jobClass', 'description'];
        return loadQuery<TQuery>(
            relayEnv,
            relayReq,
            { ...ctx.deps, searchBy },
            { fetchPolicy: 'store-and-network' }
        );
    },
    validateSearch: jobsSearchSchema,
});
